<template>
    <div class="page-content px-0 mx-0" style="margin: 0px; ">
        <SelectEvents></SelectEvents>
    </div>
</template>

<script>
import SelectEvents from "@/modules/recording/page/public/SelectEvents";
import names from '@/modules/recording/routers/names'
import {getInstMenu, getInstNameByRouterName} from "@/helper/instances";
import {isAuthenticated,} from "@/helper";

export default {
        name: "Base",
        components: {SelectEvents},
        data() {
            return {}
        },
        methods: {
            loadLeftmenu() {

                if (isAuthenticated()) {
                    this.$store.commit('leftmenu/replaceInstances', getInstMenu());
                    this.$store.commit('leftmenu/selectInstance', getInstNameByRouterName(names.BASE));
                    this.$store.commit('leftmenu/replaceItems', this.getLeftMenu());
                } else {
                    this.$store.commit('leftmenu/dissable');
                }
            },
            getLeftMenu() {
              let with_category_uid = (name) => {
                return {name: name, params: {category: this.$route.params.category}}
              };
              let menu = []
              menu.push({
                title: 'Перечень категорий',
                icon: 'view_list',
                router: with_category_uid(names.BASE),
                // included: [],
              })
              menu.push({
                    title: 'Мои записи',
                    icon: 'view_list',
                    router: names.PUBLIC.MYEVENTS,
                  }
              )
              return menu
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.loadLeftmenu()
            next()
        },
        created() {
            if (isAuthenticated() || this.$route.name === names.BASE) {
                this.$store.commit('leftmenu/enableLeftMenu');
              // this.$store.commit('leftmenu/hide');
            }
            this.loadLeftmenu()
        }
    }
</script>

<style scoped>
    .border-right {
        border-right: 2px solid var(--steel-gray);
    }

</style>
